module.exports = __webpack_public_path__ + "static/media/sekolah_koding_logo.fe5ded48.png";